import React from "react";
import createReactClass from "create-react-class";

import ModalAlbumCreate from "./modal_album_create";
import ModalAlert from "../modal/modal_alert";

export default createReactClass({
  displayName: "Root",
  getInitialState() {
    return {
      isAlbumCreatModalOpen: false,
      fadeClassName: "fade-in",
      scrollPos: 0,
    };
  },
  openModal() {
    var scrollPos = $("body").scrollTop();
    var marginLeft =
      (window.innerWidth - $("body .container").outerWidth()) / 2;
    $("body").css({
      position: "fixed",
      marginTop: -scrollPos,
      marginLeft: marginLeft,
    });
    this.setState({
      isAlbumCreatModalOpen: true,
      fadeClassName: "fade-in",
      scrollPos: scrollPos,
    });
  },
  closeModal() {
    $("body").css({ position: "relative", marginTop: "0", marginLeft: "0" });
    $("body").scrollTop(this.state.scrollPos);
    this.setState({
      fadeClassName: "fade-out",
    });
    setTimeout(
      function() {
        this.setState({
          isAlbumCreatModalOpen: false,
        });
      }.bind(this),
      300
    );
  },
  handleSettingButton() {
    this.openModal();
  },
  showAlbumCreateError() {
    this.modalAlertAlbumCreateError.openModal();
  },
  showNetworkError() {
    this.modalAlertNetworkError.openModal();
  },
  showPublicSettingError() {
    this.modalAlertPublicSettingError.openModal();
  },
  showStrageError() {
    this.modalAlertStrageError.openModal();
  },
  render() {
    return (
      <div>
        <ModalAlbumCreate
          isOpen={this.state.isAlbumCreatModalOpen}
          closeModal={this.closeModal}
          fadeClassName={this.state.fadeClassName}
          publicTypeData={this.props.publicTypeData}
          initialTitle={this.props.album.title}
          initialPublicType={this.props.album.public_type}
          initialDesctription={this.props.album.description}
          circleId={this.props.album.circle_id}
          albumId={this.props.album.id}
          isEditMode={true}
          photoStrageLimit={this.props.photoStrageLimit}
          chargePlanType={this.props.chargePlanType}
          isCirclePrivate={this.props.isCirclePrivate}
          showAlbumCreateError={this.showAlbumCreateError}
          showNetworkError={this.showNetworkError}
          showPublicSettingError={this.showPublicSettingError}
          showStrageError={this.showStrageError}
        />
        <div className="display-1 mt-4 mb-4 border-bottom">
          {this.props.myMemberType === 1 ? (
            <div style={{ float: "right", fontSize: "25px" }}>
              <a onClick={this.handleSettingButton} style={{ color: "#ccc" }}>
                <i className="fas fa-cog" aria-hidden="true" />
              </a>
            </div>
          ) : (
            ""
          )}
          <h4>
            {this.props.album.title}&nbsp;
            <span
              className="label label-warning"
              style={{
                backgroundColor: this.props.publicTypeData[
                  this.props.album.public_type
                ].color,
                fontSize: "10px",
                verticalAlign: "5px",
              }}
            >
              <i
                className={
                  this.props.publicTypeData[this.props.album.public_type].icon
                }
                aria-hidden="true"
              />{" "}
              {this.props.publicTypeData[this.props.album.public_type].name}
            </span>
          </h4>
          <h5 className="mb-3">{this.props.album.description}</h5>
          {/* TODO URLチェック結果を反映したい */}
          <p style={{ textAlign: "right", marginBottom: "0px" }}>{}</p>
        </div>

        <ModalAlert
          ref={(c) => {
            this.modalAlertAlbumCreateError = c;
          }}
          title="エラー"
          content="アルバムの作成に失敗しました。後でもう一度試すか、運営にお問い合わせください。"
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertNetworkError = c;
          }}
          title="エラー"
          content="ネットワークエラーが発生しました。後でもう一度試してください。"
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertPublicSettingError = c;
          }}
          title="公開範囲"
          content="サークルの公開設定が「非公開」なので、公開範囲を「サークルメンバー」でアルバムを保存することができません。サークルの公開設定を「公開」にするか、アルバムの公開範囲を「サークルメンバー」に設定してください。"
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertStrageError = c;
          }}
          title="容量制限"
          content="プライベートストレージの制限を超えているので、公開範囲を「サークルメンバー」でアルバムを保存することができません。アルバムの公開範囲を「公開」に設定するか、他の画像を削除してください。また、有料プランに加入するとプライベートストレージの制限を解除できます。"
        />
      </div>
    );
  },
});
